import type { Rule } from 'antd/es/form';
import i18n from '../i18n';

export const validateNumber = (_: Rule, value: string): Promise<void> => {
  if (!value || /^\d+$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(i18n.t('validator.numberError')));
};

export const validateFloatNumber = (_: Rule, value: string): Promise<void> => {
  if (!value || /^-?\d+(\.\d+)?$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(i18n.t('validator.floatNumberError')));
};

export const validateNumberInRange =
  (low: number, high: number) =>
  (_: Rule, value: string): Promise<void> => {
    const numericValue = Number(value);

    if (numericValue < low || numericValue > high) {
      return Promise.reject(new Error(i18n.t('validator.gradeError')));
    }

    return Promise.resolve();
  };
